import { useState } from "react";
import { toast } from "sonner";
import { MailWarning, Loader2 } from "lucide-react";
import { useAuth } from "@/stores/authStore";
import { authService } from "@/services/authService";
import { apiError } from "@/services/api";

export function VerifyEmailBanner() {
  const { ctx } = useAuth();
  const [sending, setSending] = useState(false);
  if (!ctx || ctx.is_super_admin || ctx.user?.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      await authService.resendVerification();
      toast.success("Verifieringsmejl skickat. Kolla din inkorg.");
    } catch (e) { toast.error(apiError(e)); }
    finally { setSending(false); }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2.5 lg:px-8"
      data-testid="verify-email-banner">
      <div className="flex items-center gap-2 text-sm">
        <MailWarning className="h-4 w-4 text-amber-600" />
        <span>Verifiera din e-postadress för att aktivera alla funktioner.</span>
      </div>
      <button onClick={resend} disabled={sending}
        className="inline-flex items-center gap-1.5 rounded-md border border-amber-500/40 px-3 py-1 text-sm font-medium hover:bg-amber-500/15"
        data-testid="banner-resend-verification">
        {sending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Skicka igen"}
      </button>
    </div>
  );
}
